var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcCautionFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3334 9.99999C18.3334 14.6024 14.6025 18.3333 10.0001 18.3333C5.39771 18.3333 1.66675 14.6024 1.66675 9.99999C1.66675 5.39762 5.39771 1.66666 10.0001 1.66666C14.6025 1.66666 18.3334 5.39762 18.3334 9.99999ZM9.60699 4.79166C9.12179 4.79166 8.72191 5.18772 8.75161 5.67438L9.10768 11.5077C9.13495 11.9545 9.5162 12.2917 9.96305 12.2917H10.0371C10.484 12.2917 10.8652 11.9545 10.8925 11.5077L11.2486 5.67438C11.2783 5.18772 10.8784 4.79166 10.3932 4.79166H9.60699ZM10.0004 13.125C9.42511 13.125 8.95842 13.5914 8.95842 14.1667C8.95842 14.742 9.42511 15.2083 10.0004 15.2083C10.5752 15.2083 11.0417 14.7418 11.0417 14.1667C11.0417 13.5915 10.5752 13.125 10.0004 13.125Z",
    fill: "#F52388"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCautionFilled);
export default __webpack_public_path__ + "static/media/ic_caution_filled.f5b02364fa517ae6917c66fa0fed937c.svg";
export { ForwardRef as ReactComponent };